module.exports = __webpack_public_path__ + "static/img/step2.bd02a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/step2.png
// module id = oR8K
// module chunks = 0